import React, { useCallback, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import StudentCourseItemMobile from "../StudentCourseItemMobile";

interface Props {
  onSelect?: (k?: string) => void;
  data?: any;
  activeLesson?: number;
  onClickExercise?: (val: any, typeClick?: "exercise" | "course") => void;
  searchData?: any[];
  search?: string;
}

const StudentFolderTabs = ({
  onSelect,
  data,
  activeLesson,
  searchData,
  onClickExercise,
  search
}: Props) => {
  const [activeTab, setActiveTab] = useState("bidding");

  const renderTab = useCallback(
    (val: string) => {
      return (
        <>
          {search &&
            searchData?.map((val) => {
              return (
                <StudentCourseItemMobile
                  key={`search-${val?.courseId}-${val?.interactive}-${val?.bidPlay}`}
                  data={val}
                  activeLesson={activeLesson}
                  onClickExercise={onClickExercise}
                />
              );
            })}
          {!search &&
            data?.[val] &&
            data?.[val]?.map((val, index) => {
              return (
                <StudentCourseItemMobile
                  key={`${val?.courseId}-${val?.interactive}-${val?.bidPlay}`}
                  id={`${index}`}
                  data={val}
                  activeLesson={activeLesson}
                  onClickExercise={onClickExercise}
                />
              );
            })}
        </>
      );
    },
    [activeLesson, data, onClickExercise, search, searchData]
  );

  return (
    <div className="tab-courses-mobile">
      <Tabs
        defaultActiveKey="bidding"
        className="mb-3"
        activeKey={activeTab}
        onSelect={(k: string) => {
          setActiveTab(k);
          onSelect && onSelect(k);
        }}>
        <Tab eventKey="bidding" title="הכרזות" key="bidding">
          {renderTab("bidding")}
        </Tab>
        <Tab eventKey="handPlay" title="משחק יד" key="handPlay">
          {renderTab("handPlay")}
        </Tab>
        <Tab eventKey="deffense" title="הגנה" key="deffense">
          {renderTab("deffense")}
        </Tab>
        <Tab eventKey="tricks" title="לקיחות" key="tricks">
          {renderTab("tricks")}
        </Tab>
        <Tab eventKey="defLead" title="הובלות" key="defLead">
          {renderTab("defLead")}
        </Tab>
        {/* <Tab eventKey="miniBridge" title="מיני ברידג'" key="miniBridge">
          {renderTab("miniBridge")}
        </Tab> */}
      </Tabs>
    </div>
  );
};

export default StudentFolderTabs;
